import React from 'react'

export const TargetMarginsView = (props) => {
    return <div>
        <label>GB</label>
        <input type="number" name="gb" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.gb).toString()}></input>
        <label>EU</label>
        <input type="number" name="eu" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.eu).toString()}></input>
        <label>US</label>
        <input type="number" name="us" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.us).toString()}></input>
        <label>ROW</label>
        <input type="number" name="row" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.row).toString()}></input>
        <label>CA</label>
        <input type="number" name="ca" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.ca).toString()}></input>
        <label>AU</label>
        <input type="number" name="au" min="-50" max="95" onChange={(e) => props.onChangeTargetMargin(e)} value={Number(props.targetMargins.au).toString()}></input>

    </div>
}